import React from 'react';
import { formatMoney } from '../../utils/money';

/** Read-only table of the saved bill: services, stylist, amounts and totals. */
export default function BillLines({ bill }) {
  const items = bill.items || [];
  return (
    <div className="dp-table-wrap">
      <table className="dp-table">
        <thead>
          <tr>
            <th>Service</th>
            <th>Stylist</th>
            <th className="num">Qty</th>
            <th className="num">Price</th>
            <th className="num">Amount</th>
          </tr>
        </thead>
        <tbody>
          {items.length ? (
            items.map((it) => (
              <tr key={it.id}>
                <td>{it.name}</td>
                <td>{it.stylist_name || '—'}</td>
                <td className="num">{it.quantity}</td>
                <td className="num">{formatMoney(it.unit_price)}</td>
                <td className="num">{formatMoney(it.line_total)}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5} className="dp-muted">
                No services on this bill.
              </td>
            </tr>
          )}
        </tbody>
        <tfoot>
          <tr>
            <td colSpan={4}>Subtotal</td>
            <td className="num">{formatMoney(bill.subtotal)}</td>
          </tr>
          {Number(bill.discount_amount) > 0 ? (
            <tr>
              <td colSpan={4}>{bill.discount_label || 'Discount'}</td>
              <td className="num">− {formatMoney(bill.discount_amount)}</td>
            </tr>
          ) : null}
          <tr>
            <td colSpan={4}>Tax ({Math.round((Number(bill.tax_rate) || 0) * 100)}%)</td>
            <td className="num">{formatMoney(bill.tax_amount)}</td>
          </tr>
          <tr className="dp-grand">
            <td colSpan={4}>Grand total</td>
            <td className="num">{formatMoney(bill.grand_total)}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
}
